import * as types from './actionTypes'

export function startReciveEntry() {
  return { type: types.BEGIN_ADD_ENTRY }
}
export function finishReciveEntry() {
  return { type: types.FINISH_ADD_ENTRY }
}

export function reciveEntry(entry) {
  return { type: types.ADD_ENTRY, entry }
}

export function startReciveImage() {
  return { type: types.BEGIN_ADD_IMAGE }
}

export function finishReciveImage() {
  return { type: types.FINISH_ADD_IMAGE }
}

export function reciveImage(image, date, side) {
  return { type: types.ADD_IMAGE, image, date, side }
}

export function addImage(image, date, side) {
  return (dispatch) => {
    dispatch(startReciveImage())
    dispatch(reciveImage(image, date, side))
    dispatch(finishReciveImage())
  }
}

export function addEntry(entry) {
  return (dispatch) => {
    dispatch(startReciveEntry())
    dispatch(reciveEntry(entry))
    dispatch(finishReciveEntry())
  }
}
